import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0;
`

export const Text = styled.div`
    font-size: 48px;
    font-weight: 700;
    margin: 0 16px;

    @media (max-width: 768px) {
        font-size: 32px;
        margin: 0 12px;
    }

    @media (max-width: 400px) {
        font-size: 24px;
        margin: 0 8px;
    }
`

export const ArrowButton = styled.button`
    background: transparent;
    border: none;
    font-weight: bold;
    font-size: 48px;
    cursor: pointer;
    padding-top: 6px;

    @media (max-width: 768px) {
        font-size: 32px;
        padding-top: 4px;
    }

    @media (max-width: 400px) {
        font-size: 24px;
        padding-top: 2px;
    }
`
